// Material UI
import { Box, Grid, Paper, Typography } from '@mui/material';
import SwapVertIcon from '@mui/icons-material/SwapVert';

// Components
import BundlesTable from './BundlesTable';
import Tooltip from 'components/popups/Tooltip';
import { ActionButton } from 'components/ui/buttons';
import { LoadingState, ErrorState } from 'components/ui/states';
import { matchesBundleFilter, shouldShowBundleList } from '../productFilters';

export default function BundleList({
    event,
    status,
    bundles,
    searchText,
    selectedFilter,
    compact = false,
    onBundleEdit,
    onOpenReorder,
}) {
    if (!shouldShowBundleList(selectedFilter)) {
        return null;
    }

    if (status === 'loading') {
        return (
            <Box mb={8}>
                <LoadingState />
            </Box>
        );
    }

    if (status === 'error') {
        return (
            <Box mb={8}>
                <ErrorState message="Unable to find bundles" />
            </Box>
        );
    }

    const normalizedSearchText = searchText.trim().toLowerCase();
    const filteredBundles = bundles
        .filter((bundle) => bundle.bundle_name?.toLowerCase().includes(normalizedSearchText))
        .filter((bundle) => matchesBundleFilter(bundle, selectedFilter, event?.time_zone));

    return (
        <Box mb={8}>
            <Paper>
                <BundleSection
                    helperText="Groups of tickets sold together as one package."
                    onOpenReorder={onOpenReorder}
                    enableReorder={bundles.length > 1}
                    title="Bundles"
                    tooltip="Choose the order your ticket types appear on the purchase page."
                />
                <BundlesTable
                    event={event}
                    bundles={filteredBundles}
                    compact={compact}
                    onBundleSelect={onBundleEdit}
                />
            </Paper>
        </Box>
    );
}

function BundleSection(props) {
    const { helperText, onOpenReorder, enableReorder, title, tooltip } = props;

    return (
        <Grid container alignItems="center" p={2} py={1} bgcolor={'#eee'}>
            <Grid item xs={12} sm={7}>
                <Typography variant="overline" fontWeight="bold" lineHeight={1.2}>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {helperText}
                </Typography>
            </Grid>

            {enableReorder && (
                <Grid item xs={12} sm={5} display="flex" justifyContent="flex-end">
                    <Tooltip message={tooltip}>
                        <span>
                            <ActionButton
                                variant="text"
                                startIcon={<SwapVertIcon />}
                                onClick={onOpenReorder}
                            >
                                Set Display Order
                            </ActionButton>
                        </span>
                    </Tooltip>
                </Grid>
            )}
        </Grid>
    );
}
